import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_format_date = _resolveComponent("app-format-date")!

  return (_openBlock(), _createBlock(_component_app_format_date, {
    value: _ctx.value,
    format: _ctx.format
  }, null, 8, ["value", "format"]))
}